


var reviewScore = 4.8;

/*

var reviewScore = sessionStorage.getItem('googleReviewScore');

if(!reviewScore){
  
  var targetDiv = document.getElementById('google_review_map');


var service = new google.maps.places.PlacesService(targetDiv);
    // set.getDetails takes 2 arguments: request, callback
    // see documentation here:  https://developers.google.com/maps/documentation/javascript/3.exp/reference#PlacesService
    const request = {
      placeId: 'ChIJ0RChh5L_e0gRDhWHBASdUJg',
      fields: ['name', 'rating', 'user_ratings_total']
    };

    // the callback is what initiates the rendering if Status returns OK
    var callback = function(place, status) {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
       reviewScore = place.rating;
       sessionStorage.setItem('googleReviewScore', reviewScore);
       showReview(reviewScore);
      }
    }

   
      service.getDetails(request, callback);
  
}else{
  showReview(reviewScore)
}
*/







function showReview(reviewScore){
  $("#google_review_score").append(reviewScore);
  	var starsWidth = reviewScore * 21;

  	$("#google_review_orange_stars_wrapper").width(starsWidth+"px");
}

showReview(reviewScore);

  	
    


  